(() => {
function initGuide(root, signal) {
  'use strict';
  const local=s=>s.replace(/#([\w-]+)/g,(_,id)=>'[data-part="'+id+'"]');
  const $=s=>root.querySelector(local(s)), all=s=>root.querySelectorAll(local(s));
  const t=value=>value;
  const step=(name,text,key,value,field='',hold=false,hint='')=>({name:t(name),text:t(text),key,value,field,hold,hint});
  const topics={
    power:{title:'Power on',steps:[step('Power On','Hold 2 sec','power','12:00','',true)]},
    clock:{title:'Set the time',steps:[step('Enter Set','','power','12:00'),step('Set Hour','+ / − to adjust','adjust','12:00','hour'),step('Set Minute','+ / − to adjust','adjust','12:00','minute'),step('12/24H','','adjust','24H','format'),step('Save','','none','12:00')]},
    alarm:{title:'Set the alarm',steps:[step('Enter Set','','alarm','07:00'),step('Set Hour','+ / − to adjust','adjust','07:00','hour'),step('Set Minute','+ / − to adjust','adjust','07:00','minute'),step('Save','','none','12:00')]},
    toggle:{title:'Turn alarm on/off',steps:[step('Alarm On/Off','Hold 2 sec','alarm','12:00','',true)]},
    response:{title:'Snooze or stop',steps:[step('Snooze','Again in 9 min','power','07:30'),step('Stop Today','Stops today','alarm','07:30')]}
  };
let alarmEnabled=false;
  let topic='power',mode='manual',index=0,timer=null,raf=null,start=0,paused=false,completed=false,value='12:00',adjusted=false;
  let responseAnswered=false;
  let clockValue='12:00', alarmValue='07:00', formatValue='24H', powered=false, holdApplied=false;
  let elapsed=0, lastTick=0, playbackFrame=null, jobs=[], holdStart=null;
  function schedule(fn, delay){ jobs.push({at:elapsed+delay,fn}); startPlayback(); }
  function startPlayback(){
    if(playbackFrame!==null||paused)return;
    lastTick=performance.now(); playbackFrame=requestAnimationFrame(tickPlayback);
  }
  function tickPlayback(now){
    playbackFrame=null;
    if(paused)return;
    elapsed+=now-lastTick; lastTick=now;
    if(holdStart!==null){
      const duration=elapsed-holdStart;
      $('#hold').hidden=duration<0;
      $('#hold').value=Math.min(2000,Math.max(0,duration)/1800*2000);
    }
    const due=jobs.filter(job=>job.at<=elapsed);
    jobs=jobs.filter(job=>job.at>elapsed);
    due.forEach(job=>job.fn());
    if((jobs.length||holdStart!==null)&&playbackFrame===null)playbackFrame=requestAnimationFrame(tickPlayback);
  }
  function setPaused(next){
    paused=next;
    if(paused){cancelAnimationFrame(playbackFrame);playbackFrame=null;}
    else startPlayback();
    $('#lesson').classList.toggle('playback-paused',paused);
    playbackIcon();
  }
  function updateText(selector,text){
    const el=$(selector);
    if(el.textContent===text)return;
    el.getAnimations().forEach(animation=>animation.cancel());
    const hadText=Boolean(el.textContent);
    el.textContent=text;
    if(hadText&&text&&!matchMedia('(prefers-reduced-motion: reduce)').matches)
      el.animate([{transform:'translateX(12px)'},{transform:'translateX(0)'}],{duration:280,easing:'ease-out'});
  }
  const patterns = {
    // Three LEDs per segment; four corners of each loop remain unlit.
    '0':['01110','10001','10001','10001','00000','10001','10001','10001','01110'],
    '1':['00000','00001','00001','00001','00000','00001','00001','00001','00000'],
    '2':['01110','00001','00001','00001','01110','10000','10000','10000','01110'],
    '3':['01110','00001','00001','00001','01110','00001','00001','00001','01110'],
    '4':['00000','10001','10001','10001','01110','00001','00001','00001','00000'],
    '5':['01110','10000','10000','10000','01110','00001','00001','00001','01110'],
    '6':['01110','10000','10000','10000','01110','10001','10001','10001','01110'],
    '7':['01110','00001','00001','00001','00000','00001','00001','00001','00000'],
    '8':['01110','10001','10001','10001','01110','10001','10001','10001','01110'],
    '9':['01110','10001','10001','10001','01110','00001','00001','00001','01110'],
    'H':['00000','10001','10001','10001','01110','10001','10001','10001','00000']
  };
function clear(){jobs=[];holdStart=null;cancelAnimationFrame(playbackFrame);playbackFrame=null;clearTimeout(timer);timer=null;cancelAnimationFrame(raf);raf=null;const holdBar=$('#hold');holdBar.hidden=true;holdBar.value=0;holdBar.classList.remove('hold-complete');const finger=$('#demo-finger');if(finger)finger.classList.remove('pressing','holding');}
function screen(){const s=topics[topic].steps[index],screenOff=topic==='power'&&!powered&&!$('#lesson').hidden;let rows=value.includes(':')?value.split(':'):[value.slice(0,2),' H'];const blinkRow=!completed&&(s.field==='hour'||s.field==='format')?0:!completed&&s.field==='minute'?1:-1;const frameKey=screenOff?'off':value+'|'+blinkRow;if($('#digits').dataset.frame!==frameKey){$('#digits').dataset.frame=frameKey;$('#digits').innerHTML=screenOff?'':rows.map((row,r)=>'<g class="'+(r===blinkRow?'blink':'')+'">'+[...row].map((c,col)=>{const p=patterns[c]||[];return p.map((line,j)=>[...line].map((v,i)=>v==='1'?'<circle cx="'+(7+col*32+i*5)+'" cy="'+(4+r*57+j*5)+'" r="1.55"/>':'').join('')).join('');}).join('')+'</g>').join('');}$('#battery').style.visibility=screenOff?'hidden':'visible';$('#indicator').style.visibility=screenOff?'hidden':'visible';updateIndicator(!screenOff&&(topic==='response'||alarmEnabled));$('#watch').classList.toggle('vibrate',topic==='response'&&!completed&&!responseAnswered);}
  function updateIndicator(lit){
    const indicator=$('#indicator');
    const wasLit=indicator.dataset.lit==='true';
    indicator.setAttribute('fill',lit?'#fff':'#5d635f');
    indicator.dataset.lit=String(lit);
    if(!lit)indicator.classList.remove('indicator-flash');
    else if(!wasLit){
      indicator.classList.remove('indicator-flash');
      void indicator.getBoundingClientRect();
      indicator.classList.add('indicator-flash');
    }
  }
  function show(id){
    clear();['menu','lesson'].forEach(x=>$('#'+x).hidden=x!==id);
    $('#learning-topics').hidden=$('#start-learning').getAttribute('aria-expanded')!=='true';
    all('[data-chapter]').forEach(b=>b.setAttribute('aria-pressed',String(id==='lesson'&&b.dataset.chapter===topic)));
  }
function render(){clear();const s=topics[topic].steps[index];$('#topic').textContent=t(topics[topic].title);updateText('#action',completed?t('Try it on your watch'):s.text);updateText('#hint','');const route=$('#route');if(route.dataset.topic!==topic){route.dataset.topic=topic;route.replaceChildren(...topics[topic].steps.map(x=>{const node=document.createElement('span');node.textContent=x.name;return node;}));}Array.from(route.children).forEach((node,i)=>node.classList.toggle('current',i===index));all('[data-key]').forEach(b=>{const entryKeys=topic==='response'?['power','alarm']:[topic==='power'||topic==='clock'?'power':'alarm'];const active=((completed||s.key==='none')&&entryKeys.includes(b.dataset.key))||(topic==='power'&&b.dataset.key==='power')||!completed&&(s.key===b.dataset.key||s.key==='adjust'&&['plus','minus',topic==='clock'?'power':'alarm'].includes(b.dataset.key));b.classList.toggle('active',active);b.disabled=mode==='auto'||completed;});all('[data-mode]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.mode===mode)));$('#pause').hidden=mode!=='auto';$('#lesson').classList.toggle('playback-paused',paused);playbackIcon();screen();updateKeyCue();animateStep();$('#alarm-indicator-callout').hidden=topic!=='toggle';if(mode==='auto'&&!completed){
  if(s.hold){demoHoldProgress();schedule(advance,3700);}
  else if(s.key==='adjust'){
    // The finger reaches full contact at .9s + 35% of its 1.2s press.
    schedule(()=>change(1),1320);
    schedule(()=>{pointTo('minus');schedule(()=>change(-1),1320);},2500);
    schedule(()=>{pointTo(topic==='clock'?'power':'alarm');schedule(advance,1320);},5000);
  }else schedule(advance,s.key==='none'?1200:1320);
}else if(mode==='manual'&&!completed&&s.key==='none'){schedule(advance,1200);}if(mode==='auto'&&completed)schedule(reset,3500);}
  function pointTo(key){
    all('[data-key]').forEach(b=>b.classList.toggle('pointed',!completed&&b.dataset.key===key));
    let finger=$('#demo-finger');
    if(key==='none'){if(finger)finger.hidden=true;return;}
    if(!finger){
      finger=document.createElement('span');finger.id='kl245-'+root.dataset.sectionId+'-demo-finger';finger.dataset.part='demo-finger';finger.setAttribute('aria-hidden','true');
      finger.innerHTML='<svg viewBox="0 0 36 48"><path d="M12 26V6c0-5 7-5 7 0v13c2-4 7-3 7 1 3-3 7-1 7 3v12c0 6-4 10-8 11H14c-3-2-5-6-7-9l-5-8c-2-4 3-7 6-4l4 4" fill="white" stroke="#34485e" stroke-width="2" stroke-linejoin="round"/></svg>';
      $('.stage').appendChild(finger);
    }
    finger.hidden=completed;
    finger.dataset.side=['plus','minus'].includes(key)?'left':'right';
    finger.dataset.row=['minus','alarm'].includes(key)?'lower':'upper';
    $('#hold').dataset.side=finger.dataset.side;
    $('#hold').dataset.row=finger.dataset.row;
    finger.classList.remove('pressing','holding');
    void finger.offsetWidth;
    if(mode==='auto'&&!completed)finger.classList.add(topics[topic].steps[index].hold?'holding':'pressing');
  }
  function animateStep(){
    const route=$('#route'),current=route.querySelector('.current');
    if(!current)return;
    const first=route.firstElementChild,last=route.lastElementChild;
    route.style.paddingLeft=Math.max(0,(route.clientWidth-first.offsetWidth)/2)+'px';
    route.style.paddingRight=Math.max(0,(route.clientWidth-last.offsetWidth)/2)+'px';
    const viewport=route.getBoundingClientRect(),item=current.getBoundingClientRect();
    const left=route.scrollLeft+item.left+item.width/2-(viewport.left+route.clientLeft+route.clientWidth/2);
    if(Math.abs(left-route.scrollLeft)>.5)
      route.scrollTo({left,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
  }
  function applyHold(){
    if(holdApplied)return;
    holdApplied=true;
    if(topic==='power')powered=true;
    if(topic==='toggle')alarmEnabled=!alarmEnabled;
    screen();
  }
  function demoHoldProgress(){
    holdStart=elapsed+1300;
    schedule(()=>{holdStart=null;showHoldComplete();},3100);
    // Full contact starts at 1.3s; the real long press completes two seconds later.
    schedule(applyHold,3300);
  }
  function showHoldComplete(after){
    const holdBar=$('#hold');
    holdBar.hidden=false;holdBar.value=2000;holdBar.classList.add('hold-complete');
    schedule(()=>{holdBar.hidden=true;holdBar.classList.remove('hold-complete');if(after)after();},300);
  }
  function updateKeyCue(){
    const s=topics[topic].steps[index], power=$('[data-key="power"]');
    const label=topic==='response'?'Snooze':topic==='clock'&&!completed&&s.key==='adjust'?(s.field==='format'?'SAVE':'NEXT'):'POWER';
    power.innerHTML='<b></b><span>'+t(label)+'</span>';
    power.setAttribute('aria-label',label==='POWER'?t('Power button'):t('Power button')+' — '+t(label));
    const alarm=$('[data-key="alarm"]');
    const alarmLabel=topic==='response'?'Stop':topic==='alarm'&&!completed&&s.key==='adjust'?(s.field==='minute'?'SAVE':'NEXT'):'ALARM';
    alarm.innerHTML='<svg class="kb-bell" viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true"><path d="M12 2a1 1 0 0 0-1 1v.1A6 6 0 0 0 6 9v4l-2 3v2h16v-2l-2-3V9a6 6 0 0 0-5-5.9V3a1 1 0 0 0-1-1Zm-2 18a2 2 0 0 0 4 0Z"/></svg><span>'+t(alarmLabel)+'</span>';
    alarm.setAttribute('aria-label',alarmLabel==='ALARM'?t('Alarm button'):t('Alarm button')+' — '+t(alarmLabel));
    pointTo(s.key==='adjust'?'plus':s.key);
  }
  function playbackIcon(){
    const button=$('#pause'),label=paused?'Play':'Pause';
    button.setAttribute('aria-label',t(label));button.title=t(label);
    button.innerHTML='<svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">'+(paused?'<path d="M7 4v16l14-8z"/>':'<path d="M6 4h4v16H6zM14 4h4v16h-4z"/>')+'</svg>';
  }
  function advance(){
    if(completed)return;
    if(topic==='response'&&!responseAnswered){
      responseAnswered=true;
      screen();
      schedule(advance,1600);
      return;
    }
    responseAnswered=false;
    if(topics[topic].steps[index].hold)applyHold();
    if(index<topics[topic].steps.length-1){
      index++;adjusted=false;
      const next=topics[topic].steps[index];
      if(next.field==='format')value=formatValue;
      else if(next.key==='none')value=clockValue;
      else if(next.field==='hour'||next.field==='minute')value=topic==='clock'?clockValue:alarmValue;
    }else completed=true;
    render();
  }
  function change(delta){
    const s=topics[topic].steps[index];
    if(s.field==='format'){formatValue=formatValue==='24H'?'12H':'24H';value=formatValue;}
    else{
      const parts=value.split(':').map(Number),n=s.field==='hour'?0:1,max=n===0?24:60;
      parts[n]=(parts[n]+delta+max)%max;
      value=parts.map(x=>String(x).padStart(2,'0')).join(':');
      if(topic==='clock')clockValue=value;else alarmValue=value;
    }
    adjusted=true;screen();
  }
  function press(key){if(mode!=='manual'||completed||responseAnswered)return;const s=topics[topic].steps[index];if(s.hold)return;if(s.key==='adjust'){if(['plus','minus'].includes(key))change(key==='plus'?1:-1);else if(key===(topic==='clock'?'power':'alarm'))advance();}else if(key===s.key)advance();}
  function hold(key){const s=topics[topic].steps[index];if(mode!=='manual'||completed||!s.hold||s.key!==key||raf!==null)return;start=performance.now();$('#hold').hidden=false;const tick=now=>{$('#hold').value=now-start;if(now-start>=2000){raf=null;applyHold();showHoldComplete(advance);}else raf=requestAnimationFrame(tick);};raf=requestAnimationFrame(tick);}
all('[data-key]').forEach(b=>{b.onclick=()=>press(b.dataset.key);b.onpointerdown=e=>{b.setPointerCapture(e.pointerId);hold(b.dataset.key);};b.onpointerup=b.onpointercancel=b.onlostpointercapture=()=>{cancelAnimationFrame(raf);raf=null;if(!$('#hold').classList.contains('hold-complete'))$('#hold').hidden=true;};b.onkeydown=e=>{if([' ','Enter'].includes(e.key)){e.preventDefault();if(!e.repeat)hold(b.dataset.key);}};b.onkeyup=e=>{if([' ','Enter'].includes(e.key)){e.preventDefault();cancelAnimationFrame(raf);raf=null;if(!$('#hold').classList.contains('hold-complete'))$('#hold').hidden=true;press(b.dataset.key);}};});
  function reset(){responseAnswered=false;index=0;completed=false;adjusted=false;holdApplied=false;powered=topic!=='power';value=topic==='alarm'?alarmValue:topic==='response'?'07:30':clockValue;render();}
const chapterKeys=Object.keys(topics);
  function alignChapter(){
    const track=$('#learning-topics .chapters');
    const selected=track.querySelector('[aria-pressed="true"]');
    if(!selected)return;
    track.style.setProperty('--selected-x',selected.offsetLeft+'px');
    track.style.setProperty('--selected-width',selected.offsetWidth+'px');
  }
  function selectChapter(next){
    if(next===topic&&!$('#lesson').hidden)return;
    topic=next;mode='auto';paused=matchMedia('(prefers-reduced-motion: reduce)').matches;
    show('lesson');reset();alignChapter();
  }
  all('[data-chapter]').forEach(b=>{
    b.onclick=()=>selectChapter(b.dataset.chapter);
    b.onkeydown=e=>{
      const i=chapterKeys.indexOf(topic);
      const n=e.key==='ArrowRight'?Math.min(4,i+1):e.key==='ArrowLeft'?Math.max(0,i-1):e.key==='Home'?0:e.key==='End'?4:null;
      if(n===null)return;
      e.preventDefault();selectChapter(chapterKeys[n]);
      $('[data-chapter="'+chapterKeys[n]+'"]').focus();
    };
  });
  let swipe=null;
  $('#lesson').addEventListener('pointerdown',e=>{
    if(e.target.closest('button')||e.pointerType==='mouse')return;
    swipe={x:e.clientX,y:e.clientY,id:e.pointerId};
  });
  $('#lesson').addEventListener('pointerup',e=>{
    if(!swipe||swipe.id!==e.pointerId)return;
    const dx=e.clientX-swipe.x,dy=e.clientY-swipe.y;swipe=null;
    if(Math.abs(dx)<50||Math.abs(dx)<Math.abs(dy)*1.5)return;
    const i=chapterKeys.indexOf(topic),n=Math.max(0,Math.min(4,i+(dx<0?1:-1)));
    selectChapter(chapterKeys[n]);
  });
  $('#lesson').addEventListener('pointercancel',()=>{swipe=null;});
  $('#back').onclick=()=>show('menu');$('#restart').onclick=reset;$('#pause').onclick=()=>setPaused(!paused);document.addEventListener('visibilitychange',()=>{if(document.hidden&&mode==='auto')setPaused(true);},{signal});
  window.addEventListener('resize',()=>{if(!$('#lesson').hidden){animateStep();alignChapter();}},{signal});
  // Static home preview shares the lesson artwork, with independent SVG IDs.
  screen();
  const preview=$('#watch').cloneNode(true);
  preview.removeAttribute('id');preview.removeAttribute('data-part');
  preview.querySelectorAll('[id]').forEach(el=>{el.id='basic-'+el.id;if(el.dataset.part)el.dataset.part='basic-'+el.dataset.part;});
  preview.querySelectorAll('[fill]').forEach(el=>{el.setAttribute('fill',el.getAttribute('fill').replace('url(#','url(#basic-'));});
  $('#basic-watch').appendChild(preview);
  // Shared topic navigation sits above the watch during every lesson.
  $('#lesson').before($('#learning-topics'));
  $('#back').hidden=true;
  $('#start-learning').hidden=false;
  $('#start-learning').setAttribute('aria-expanded','false');
  $('#learning-topics').hidden=true;
  $('#learning-topics h2').textContent=t('Topics');
  $('#start-learning').onclick=()=>{
    $('#start-learning').setAttribute('aria-expanded','true');
    topic='power';
    mode='auto';
    paused=matchMedia('(prefers-reduced-motion: reduce)').matches;
    show('lesson');
    reset();
    alignChapter();
    $('#topic').tabIndex=-1;
    $('#topic').focus({preventScroll:true});
  };
return ()=>{clear();root.getAnimations({subtree:true}).forEach(animation=>animation.cancel());};
}
if(!customElements.get('kl245-interactive-guide')){
  customElements.define('kl245-interactive-guide',class extends HTMLElement{
    connectedCallback(){
      if(this.cleanup)return;
      if(!this.originalMarkup)this.originalMarkup=this.innerHTML;
      this.controller=new AbortController();
      this.cleanup=initGuide(this,this.controller.signal);
    }
    disconnectedCallback(){
      this.controller?.abort();
      this.cleanup?.();
      this.cleanup=null;
      this.innerHTML=this.originalMarkup;
    }
  });
}
})();
